import React from "react"
import BodyText from "./BodyText"

export const countFootnotes = (html = "") => {
  const matches = html.match(/<sup\b[^>]*class\s*=\s*["'][^"']*\bfootnote\b[^"']*["'][^>]*>[\s\S]*?<\/sup>/gi)

  return matches ? matches.length : 0
}

const normalizeFootnotes = (html = "", startNumber = 1) => {
  const notes = []
  let fallbackIndex = 0

  const content = html.replace(/<sup\b([^>]*)>([\s\S]*?)<\/sup>/gi, (match, attrs, inner) => {
    const classMatch = attrs.match(/class\s*=\s*["']([^"']*)["']/i)
    const classNames = classMatch ? classMatch[1] : ""

    if (!/\bfootnote\b/.test(classNames)) {
      return match
    }

    fallbackIndex += 1

    const number = startNumber + notes.length

    const idMatch = attrs.match(/data-footnote-id\s*=\s*["']([^"']+)["']/i)
    const baseId = idMatch ? idMatch[1] : `fn-${fallbackIndex}`
    const id = `${baseId}-${number}`
    const refId = `${id}-ref`
    const text = inner.replace(/<[^>]+>/g, "").trim()

    notes.push({ id, refId, text, number })

    return `<sup class="footnote-ref" id="${refId}"><a href="#${id}">${number}</a></sup>`
  })

  return { content, notes }
}

const FootnoteBody = ({ body, startNumber = 1 }) => {
  const { content, notes } = normalizeFootnotes(body, startNumber)

  return <React.Fragment>
    <BodyText body={content} />
    {notes.length ? <ol className="footnote-list">
      {notes.map((note, index) => {
        return <li key={`${note.id}-${index}`} id={note.id}>
          <a href={`#${note.refId}`} className="footnote-backref">{note.number}.</a> {note.text}
        </li>
      })}
    </ol> : null}
  </React.Fragment>
}

export default FootnoteBody